"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const colors_1 = require("../colors");
const BlockButton_1 = __importDefault(require("../Utilities/BlockButton"));
const Tab = ({ id, title, description, icon: Icon, onTabClick, isActive }) => (react_1.default.createElement(BlockButton_1.default, { "data-testid": id, className: `tab ${isActive ? 'tab-active' : ''}`, onClick: event => onTabClick(event, id) },
    Icon ? react_1.default.createElement(Icon, { "data-testid": `icon-for-${id}`, weight: "light", color: isActive ? colors_1.coal : colors_1.slate, size: "2x" }) : null,
    react_1.default.createElement("div", null,
        react_1.default.createElement("h5", { className: `tab-title ${isActive ? 'tab-title-active' : ''}` }, title),
        description ? react_1.default.createElement("p", null, description) : null)));
Tab.propTypes = {
    id: prop_types_1.default.string.isRequired,
    title: prop_types_1.default.node.isRequired,
    description: prop_types_1.default.node,
    icon: prop_types_1.default.func,
    onTabClick: prop_types_1.default.func.isRequired,
    isActive: prop_types_1.default.bool,
};
exports.default = Tab;
